module.exports = __webpack_public_path__ + "img/m11.b169d4b.jpg";